import React from "react";
import { useIntl } from "react-intl";
import AuditLogItem from "../AuditLogItem";
import Grid from "../../Unknown/Grid";
import { AuditLogListProps } from "./types";
import useTranslations from "./useTranslations";
import getAuditLogChangedBy from "./getAuditLogChangedBy";
import getAuditLogChangedAt from "./getAuditLogChangedAt";
import getAuditLogChangeEvent from "./getAuditLogChangeEvent";
import getMergeAuditLogSummary from "./getMergeAuditLogSummary";
import getMergeAuditLogFieldsEdited from "./getMergeAuditLogFieldsEdited";

const AuditLogList = ({ auditLogs, timezone }: AuditLogListProps) => {
  const { systemTitle, ...translations } = useTranslations();
  const { formatMessage } = useIntl();

  return (
    <Grid container flexDirection="column" gap={4}>
      {auditLogs.map((auditLog, index) => {
        const withUnderline = index !== auditLogs.length - 1;
        const isMergeLog = "merge_type" in auditLog;

        const changedBy = getAuditLogChangedBy(auditLog, systemTitle);
        const changedAt = getAuditLogChangedAt(auditLog, timezone);

        let changeTitle: string | undefined;
        let changedFields: string[] | null | undefined;

        if (isMergeLog) {
          changeTitle = getMergeAuditLogSummary(auditLog, formatMessage);
          changedFields = getMergeAuditLogFieldsEdited(auditLog);
        } else {
          const changeEvent = getAuditLogChangeEvent(auditLog);
          changeTitle =
            (changeEvent && translations[changeEvent]) || changeEvent;
          changedFields = auditLog.fields;
        }

        return (
          <AuditLogItem
            key={auditLog.id}
            changedAt={changedAt}
            changedBy={changedBy}
            changedTitle={changeTitle}
            changedFields={changedFields}
            hideFieldsHeader={isMergeLog}
            withUnderline={withUnderline}
          />
        );
      })}
    </Grid>
  );
};

export default AuditLogList;
